<template>
    <div class="crossSection">
        <div id="main"></div>
    </div>
</template>

<script>
import option from './option';
export default {

    props: ['subData'],
    data() {
        return {

        };
    },

    mounted() {

        this.$nextTick(()=>{
            this.init();
        });
    },

    methods: {

        init() {
            option.xAxis.data = this.subData.xData;
            option.series[0].data = this.subData.yData;
            option.series[0].areaStyle = {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                        offset: 0,
                        color: 'rgb(255, 158, 68)'
                    },
                    {
                        offset: 1,
                        color: 'rgb(255, 70, 131)'
                    }
                ])
            }
            this.$echarts.dispose(document.getElementById('main'));
            var myChart = this.$echarts.init(document.getElementById('main'));
            myChart.setOption(option);
            myChart.resize();
        }

    },
};
</script>

<style lang="scss" scoped>
.crossSection {
    width: 100%;
    height: 100%;

    #main {
        width: 100vw;
        height: 178px;
    }
}
</style>